export const generateDistance = (distance: number | undefined, totalValue: boolean = false): string => (distance !== undefined ? `${(Math.round(distance * 100) / 100)} km${distance !== undefined && totalValue ? ' in total' : ''}` : 'N/A');

export const convertMsToKm = (distance: number): number => (distance ? Math.round(distance * 3.6 * 100) / 100 : 0);

export const convertMsecToHs = (ms: number): number => Math.round((ms / 3600000) * 10) / 10;

export function calculateAverageSpeed(
  distanceKm?: number | null,
  durationMs?: number | null,
): number | null {
  if (distanceKm == null || durationMs == null || durationMs <= 0) return null;
  const durationHours = durationMs / 3_600_000; // ms → hours
  if (durationHours <= 0) return null;
  return distanceKm / durationHours;
}

export function formatSizeBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
